// Bilingual content for Felica Invest SRL
export const content = {
  it: {
    brand: {
      name: "Felica Invest",
      suffix: "SRL",
      tagline: "Investimenti immobiliari · dal 2020",
    },
    nav: {
      home: "Home",
      about: "Chi siamo",
      services: "Servizi",
      market: "Mercato",
      contact: "Contatti",
      contactCta: "Parliamone",
    },
    hero: {
      overline: "Umbria · Real Estate · Est. 2020",
      title: [
        "Il mattone",
        "come opportunità",
        "imprenditoriale.",
      ],
      lede:
        "Felica Invest SRL è una società immobiliare che seleziona, acquista e gestisce immobili residenziali e produttivi con una filosofia da investitori, non da speculatori.",
      ctaPrimary: "Scopri la nostra strategia",
      ctaSecondary: "50+ operazioni concluse",
    },
    marquee: [
      "Alto rendimento",
      "Bassi prezzi di acquisto",
      "Bassi tassi di interesse",
      "Ampia scelta",
      "Esperienza dei soci",
      "Umbria — Italia",
    ],
    manifesto: {
      overline: "Manifesto",
      title: "Cinque forze convergono. Noi le trasformiamo in valore.",
      intro:
        "Il mercato immobiliare regionale ha attraversato oltre un decennio di trasformazioni profonde. Prezzi al minimo storico, rendite in crescita, offerta abbondante. Nel contesto più complesso degli ultimi cinquant\u2019anni, si è aperta un\u2019opportunità imprenditoriale straordinaria.",
      chapters: [
        {
          n: "I",
          title: "Alto rendimento",
          body:
            "Il valore degli affitti è diminuito proporzionalmente meno rispetto ai prezzi di compravendita. La rendita annuale dell\u2019investimento immobiliare è passata da un range del 3\u20134% al 5\u20137%.",
          stat: "5\u20137%",
          statLabel: "Yield lordo annuale",
        },
        {
          n: "II",
          title: "Bassi prezzi di acquisto",
          body:
            "Il mercato secondario ha registrato una flessione media del 45%, con picchi del 60% nelle aree più sensibili. Il mattone è al minimo storico dal dopoguerra.",
          stat: "\u221245%",
          statLabel: "Prezzi mercato secondario",
        },
        {
          n: "III",
          title: "Ampia offerta",
          body:
            "La crisi ha portato in asta un\u2019offerta immobiliare senza precedenti. Un canale meno affollato dagli investitori non professionali, con minore pressione competitiva.",
          stat: "Aste",
          statLabel: "Canale privilegiato",
        },
        {
          n: "IV",
          title: "Leva finanziaria",
          body:
            "Finanziamento misto con equity e capitale di debito bancario. Diversifichiamo gli investimenti e amplifichiamo la redditività attraverso una leva prudente.",
          stat: "Equity + Debt",
          statLabel: "Struttura del capitale",
        },
        {
          n: "V",
          title: "Esperienza dei soci",
          body:
            "Oltre 50 operazioni immobiliari concluse — societarie e personali. Una rete di segnalatori consolidata, un metodo di analisi rigoroso, una gestione efficiente.",
          stat: "50+",
          statLabel: "Operazioni concluse",
        },
      ],
    },
    about: {
      overline: "Chi siamo",
      title: "Una società di investimento immobiliare, non un\u2019agenzia.",
      body:
        "Costituita nel 2020, Felica Invest SRL è di proprietà del Dott. Stefano Ferretti — investitore immobiliare — e del Dott. Fabio Lima Battistini, professionista di alto profilo dell\u2019intermediazione immobiliare. L\u2019Amministratore Unico è il Dott. Stefano Ferretti.",
      pillars: [
        {
          title: "Focus",
          body: "Immobili di grande potenzialità, selezionati attraverso una rete di segnalatori consolidata.",
        },
        {
          title: "Prezzo",
          body: "Acquisto molto al di sotto del valore di mercato. La disciplina di ingresso è il primo margine di sicurezza.",
        },
        {
          title: "Struttura",
          body: "Capitale proprio ed indebitamento bancario. Diversificazione dei rischi e amplificazione della redditività.",
        },
        {
          title: "Rischio",
          body: "Basso rischio operativo. Nessuna contaminazione con attività che possano minare il patrimonio accumulato.",
        },
      ],
      partners: [
        { role: "Investitore", name: "Dott. Stefano Ferretti", detail: "Amministratore Unico · 50% quote" },
        { role: "Operatore Immobiliare", name: "Dott. Fabio Lima Battistini", detail: "Intermediazione di alto profilo · 50% quote" },
      ],
    },
    services: {
      overline: "Servizi",
      title: "Due rami di attività. Un unico metodo.",
      a: {
        tag: "A",
        title: "Consulenza Immobiliare",
        subtitle: "Segnalazione · Brokeraggio · Ristrutturazione",
        body:
          "Attività di segnalazione e brokeraggio nella ricerca di unità immobiliari e nelle ristrutturazioni edili. Solide relazioni con operatori del settore ci permettono di accedere a immobili altrimenti invisibili al mercato.",
        bullets: [
          "Scouting su misura per investitori privati e istituzionali",
          "Analisi di fattibilità tecnica ed economica",
          "Coordinamento con imprese e professionisti di fiducia",
        ],
      },
      b: {
        tag: "B",
        title: "Gestione Operazioni Immobiliari",
        subtitle: "Asset Management",
        body:
          "Identifichiamo, acquistiamo e gestiamo immobili residenziali e produttivi. Un approccio da investitori professionali che coniuga rendimento da locazione e potenziale di rivalutazione (capital gain).",
        bullets: [
          "Selezione degli asset e due diligence",
          "Strutturazione finanziaria (equity + debito bancario)",
          "Gestione locativa e disinvestimento strategico",
        ],
      },
    },
    market: {
      overline: "Analisi di mercato",
      title: "Il mercato non aspetta. Chi comprende, agisce.",
      intro:
        "Un decennio di crisi ha ridisegnato il paradigma valore/redditività dell\u2019immobiliare italiano. Ecco cosa osserviamo nel nostro territorio di riferimento.",
      segments: [
        {
          n: "01",
          title: "Mercato Secondario",
          body:
            "Flessione media dei prezzi del 45%, con picchi del 60% in aree particolarmente sensibili — es. immobili da ristrutturare nel centro storico di Perugia o nei piccoli centri periferici dell\u2019Umbria.",
          metric: "\u221245%",
        },
        {
          n: "02",
          title: "Mercato Primario",
          body:
            "Le nuove costruzioni sono sostanzialmente ferme. Molte transazioni vengono concordate al di sotto del costo teorico di costruzione: ~€1.300/mq residenziale, ~€700/mq industriale.",
          metric: "€1.3k / €0.7k",
        },
        {
          n: "03",
          title: "Ristrutturazioni",
          body:
            "Uscita dalla fase euforica del Superbonus/Sismabonus. La bolla speculativa sui materiali e sul lavoro rientra: si aprono nuovi spazi di razionalità nei capitolati.",
          metric: "Post-bonus",
        },
      ],
      compare: {
        title: "Perché immobiliare, adesso.",
        body:
          "Per la nostra filosofia di business, l\u2019investimento immobiliare non è un semplice \u201cbene rifugio\u201d, ma un\u2019opportunità imprenditoriale da cogliere.",
        rows: [
          { label: "Rendimenti", value: "Più alti del mercato obbligazionario" },
          { label: "Rischi", value: "Minori del mercato azionario" },
          { label: "Flussi", value: "Più stabili degli investimenti aziendali" },
          { label: "Gestione", value: "Sforzo operativo contenuto" },
        ],
      },
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo di immobili.",
      lede:
        "Per opportunità di co-investimento, consulenza o segnalazione di operazioni, contatti diretti con la società.",
      companyBlock: "Dati societari",
      email: "info@felicainvest.com",
      emailLabel: "Email",
      phone: "+39 0742 771729",
      phoneLabel: "Telefono",
      address: "Via del Lavoro snc, 06033 Cannara (PG), Italia",
      addressLabel: "Sede legale",
      companyData: [
        { k: "Ragione sociale", v: "Felica Invest S.r.l." },
        { k: "Costituita nel", v: "2020" },
        { k: "Amministratore Unico", v: "Dott. Stefano Ferretti" },
        { k: "P.IVA", v: "03705750549" },
        { k: "Sede legale", v: "Via del Lavoro snc, 06033 Cannara (PG)" },
        { k: "PEC", v: "felicainvest@pec.it" },
      ],
      cta: "Scrivici",
    },
    footer: {
      claim: "Investire nel mattone come atto imprenditoriale.",
      rights: "© Felica Invest S.r.l. — Tutti i diritti riservati.",
      note: "Sito realizzato con cura editoriale.",
    },
  },
  en: {
    brand: {
      name: "Felica Invest",
      suffix: "SRL",
      tagline: "Real estate investments · since 2020",
    },
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      market: "Market",
      contact: "Contact",
      contactCta: "Get in touch",
    },
    hero: {
      overline: "Umbria · Real Estate · Est. 2020",
      title: [
        "Real estate",
        "as entrepreneurial",
        "opportunity.",
      ],
      lede:
        "Felica Invest SRL is a real estate company that selects, acquires and manages residential and productive properties with the mindset of investors — not speculators.",
      ctaPrimary: "Discover our strategy",
      ctaSecondary: "50+ deals closed",
    },
    marquee: [
      "High yield",
      "Low acquisition prices",
      "Low interest rates",
      "Wide supply",
      "Founders\u2019 experience",
      "Umbria — Italy",
    ],
    manifesto: {
      overline: "Manifesto",
      title: "Five forces converging. We turn them into value.",
      intro:
        "The regional real estate market has been through a decade of deep transformation. Historic-low prices, rising rental yields, abundant supply. In the most complex environment in fifty years, an extraordinary opportunity has opened up.",
      chapters: [
        {
          n: "I",
          title: "High yield",
          body:
            "Rental values fell proportionally less than sale prices. Annual real-estate yield has moved from a 3\u20134% range to 5\u20137%.",
          stat: "5\u20137%",
          statLabel: "Gross annual yield",
        },
        {
          n: "II",
          title: "Low acquisition prices",
          body:
            "The secondary market registered an average \u221245% correction, with peaks of \u221260% in the most sensitive areas. Real estate is at post-war historic lows.",
          stat: "\u221245%",
          statLabel: "Secondary-market prices",
        },
        {
          n: "III",
          title: "Wide supply",
          body:
            "The crisis brought unprecedented supply to court auctions. A channel less frequented by non-professional investors and, therefore, less competitive.",
          stat: "Auctions",
          statLabel: "Privileged channel",
        },
        {
          n: "IV",
          title: "Financial leverage",
          body:
            "Blended equity and bank debt. We diversify investments and amplify returns through prudent leverage.",
          stat: "Equity + Debt",
          statLabel: "Capital structure",
        },
        {
          n: "V",
          title: "Founders\u2019 experience",
          body:
            "Over 50 real estate deals closed — corporate and personal. A consolidated referral network, a rigorous analysis method, an efficient management.",
          stat: "50+",
          statLabel: "Deals closed",
        },
      ],
    },
    about: {
      overline: "About",
      title: "A real estate investment firm — not an agency.",
      body:
        "Founded in 2020, Felica Invest SRL is owned by Dr. Stefano Ferretti — real estate investor — and Dr. Fabio Lima Battistini, a senior real estate intermediation professional. Sole Director: Dr. Stefano Ferretti.",
      pillars: [
        { title: "Focus", body: "High-potential assets sourced through a consolidated referral network." },
        { title: "Price", body: "Acquisitions well below market value. Entry discipline is the first margin of safety." },
        { title: "Structure", body: "Equity and bank debt combined. Diversified risk, amplified returns." },
        { title: "Risk", body: "Low operating risk. No contamination with activities that could erode the accumulated wealth." },
      ],
      partners: [
        { role: "Investor", name: "Dr. Stefano Ferretti", detail: "Sole Director · 50% shares" },
        { role: "Real Estate Operator", name: "Dr. Fabio Lima Battistini", detail: "Senior intermediation · 50% shares" },
      ],
    },
    services: {
      overline: "Services",
      title: "Two business lines. One method.",
      a: {
        tag: "A",
        title: "Real Estate Advisory",
        subtitle: "Sourcing · Brokerage · Renovation",
        body:
          "Sourcing and brokerage on the search for properties and on refurbishment projects. Solid relationships with market operators give us access to properties that are otherwise invisible.",
        bullets: [
          "Tailored scouting for private and institutional investors",
          "Technical and economic feasibility analyses",
          "Coordination with trusted firms and professionals",
        ],
      },
      b: {
        tag: "B",
        title: "Real Estate Operations",
        subtitle: "Asset Management",
        body:
          "We identify, acquire and manage residential and productive properties. A professional-investor approach that blends rental yield and capital-gain potential.",
        bullets: [
          "Asset selection and due diligence",
          "Financial structuring (equity + bank debt)",
          "Rental management and strategic exits",
        ],
      },
    },
    market: {
      overline: "Market analysis",
      title: "The market doesn\u2019t wait. Those who understand, act.",
      intro:
        "A decade of crisis reshaped the value/yield paradigm of Italian real estate. Here is what we observe on our home ground.",
      segments: [
        {
          n: "01",
          title: "Secondary Market",
          body:
            "Average \u221245% price correction, up to \u221260% in the most sensitive areas — e.g. properties to be renovated in the historic centre of Perugia or in Umbria\u2019s smaller villages.",
          metric: "\u221245%",
        },
        {
          n: "02",
          title: "Primary Market",
          body:
            "New construction is largely on hold. Many transactions clear below the theoretical construction cost: ~€1,300/sqm residential, ~€700/sqm industrial.",
          metric: "€1.3k / €0.7k",
        },
        {
          n: "03",
          title: "Renovations",
          body:
            "The Superbonus/Sismabonus euphoria has ended. The bubble on materials and labour deflates, leaving room for rational pricing again.",
          metric: "Post-bonus",
        },
      ],
      compare: {
        title: "Why real estate, now.",
        body:
          "For our business philosophy, real estate is not merely a \u201csafe haven\u201d — it is an entrepreneurial opportunity to be seized.",
        rows: [
          { label: "Returns", value: "Higher than the bond market" },
          { label: "Risks", value: "Lower than the equity market" },
          { label: "Cash flows", value: "More stable than operating businesses" },
          { label: "Management", value: "Contained operational effort" },
        ],
      },
    },
    contact: {
      overline: "Contact",
      title: "Let\u2019s talk real estate.",
      lede:
        "For co-investment opportunities, advisory or deal referrals, reach the company directly.",
      companyBlock: "Company data",
      email: "info@felicainvest.com",
      emailLabel: "Email",
      phone: "+39 0742 771729",
      phoneLabel: "Phone",
      address: "Via del Lavoro snc, 06033 Cannara (PG), Italy",
      addressLabel: "Registered office",
      companyData: [
        { k: "Legal name", v: "Felica Invest S.r.l." },
        { k: "Founded", v: "2020" },
        { k: "Sole Director", v: "Dr. Stefano Ferretti" },
        { k: "VAT No.", v: "03705750549" },
        { k: "Registered office", v: "Via del Lavoro snc, 06033 Cannara (PG)" },
        { k: "Certified email", v: "felicainvest@pec.it" },
      ],
      cta: "Write us",
    },
    footer: {
      claim: "Investing in real estate as an entrepreneurial act.",
      rights: "© Felica Invest S.r.l. — All rights reserved.",
      note: "Editorial craft, from concept to code.",
    },
  },
};
